import { render, staticRenderFns } from "./ModalAssign.vue?vue&type=template&id=3083dc5e&scoped=true"
import script from "./ModalAssign.vue?vue&type=script&lang=js"
export * from "./ModalAssign.vue?vue&type=script&lang=js"
import style0 from "./ModalAssign.vue?vue&type=style&index=0&id=3083dc5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3083dc5e",
  null
  
)

export default component.exports